import { render, staticRenderFns } from "./DataCenter.vue?vue&type=template&id=1e8cade8&"
import script from "./DataCenter.vue?vue&type=script&lang=js&"
export * from "./DataCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports